import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { ReactComponent as BackArrowIcon } from '../../../assets/images/common/icons/programBuilder/back-arrow-icon.svg'

import styles from './BuilderFooter.module.scss'

const BuilderFooter = ({ onSaveProgram, setShowSaveModal, loader, dataLoaded }) => {
  const { t } = useTranslation()
  const programFields = useSelector(state => state.programBuilder)
  const { id, isDraft, step } = programFields

  return (
    <section className={`fixed-bottom ${styles['footer-container']}`}>
      <div className={`row ${styles.content}`}>
        {!dataLoaded && (
          <>
            <div className={`${styles['step-button']} col-12 col-sm-6 d-flex justify-content-center align-items-center`}>
              {step > 1 && (
                <NavLink to={{ search: `?step=${step - 1}` }} className={`btn btn-primary ml-sm-auto ${styles['back-button']}`}>
                  <div className='d-flex align-items-center'>
                    <BackArrowIcon aria-hidden='true' className={styles['back-icon']} />
                    <span className='mr-5'>{t('common.flow.back')}</span>
                  </div>
                </NavLink>
              )}
            </div>

            <div className={`${styles['step-button']} col-12 col-sm-6 d-flex justify-content-center align-items-center`}>
              {step < 4 ? (
                <NavLink to={{ search: `?step=${step + 1}` }} className={`btn btn-primary mr-sm-auto ${styles['next-button']}`}>
                  <div className='d-flex align-items-center'>
                    <span className='ml-5'>{t('common.flow.next')}</span>
                    <BackArrowIcon aria-hidden='true' className={styles['next-icon']} />
                  </div>
                </NavLink>
              ) : (
                <button
                  className={`btn btn-primary mr-sm-auto ${styles['save-button']}`}
                  onClick={(id && !isDraft) ? () => onSaveProgram(false) : () => setShowSaveModal(true)}
                  disabled={loader}
                >
                  {(id && !isDraft) ? t('common.save') : t('programs.builder.footer.saveOrPublish')}
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </section>
  )
}

BuilderFooter.propTypes = {
  onSaveProgram: PropTypes.func.isRequired,
  setShowSaveModal: PropTypes.func.isRequired,
  loader: PropTypes.bool.isRequired,
  dataLoaded: PropTypes.bool.isRequired,
}

export default BuilderFooter
